export const generateSlug = (title) => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .substring(0, 100);
};

export const createPropertySlug = (title, id) => {
  const baseSlug = generateSlug(title);
  return `${baseSlug}-${id}`;
};
